/**
 * Production-safe logging utility
 * Only logs in development or when explicitly enabled
 */

// Safe environment detection for Create React App
const isDevelopment = process.env.NODE_ENV === 'development';
const isDebugEnabled = typeof window !== 'undefined' && window.localStorage?.getItem('debug_mode') === 'true';

export const logger = {
  info: (...args: any[]) => {
    if (isDevelopment || isDebugEnabled) {
      console.log('[INFO]', ...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDevelopment || isDebugEnabled) {
      console.warn('[WARN]', ...args);
    }
  },
  
  error: (...args: any[]) => {
    // Always log errors, even in production
    console.error('[ERROR]', ...args);
  },
  
  debug: (...args: any[]) => {
    if (isDevelopment || isDebugEnabled) {
      console.log('[DEBUG]', ...args);
    }
  },
  
  // Performance-safe group logging
  group: (label: string, fn: () => void) => {
    if (isDevelopment || isDebugEnabled) {
      console.group(label);
      fn();
      console.groupEnd();
    }
  }
};

// Export a no-op logger for production-critical code
export const productionLogger = {
  info: () => {},
  warn: () => {},
  error: (...args: any[]) => console.error('[ERROR]', ...args),
  debug: () => {},
  group: (_label: string, fn: () => void) => fn()
};
